import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.MeasurementApplication`]: 'Measurement Application',

      [`${prefix}.Preparation.NuclearDensityGauge`]: 'Nuclear Density Gauge',
      [`${prefix}.Preparation.NuclearDensityGaugeSerialNumber`]: 'Nuclear Density Gauge Serial Number',
      [`${prefix}.Preparation.NuclearDensityGaugeMakeAndModel`]: 'Nuclear Density Gauge Make/Model',
      [`${prefix}.Preparation.TestNumber`]: 'Test Number',
      [`${prefix}.Preparation.ApplyCorrections`]: 'Apply corrections to measurements',
      [`${prefix}.Preparation.BulkDensityCorrectionSlope`]: 'Bulk Density Correction Slope (b)',
      [`${prefix}.Preparation.BulkDensityCorrectionIntercept`]: 'Bulk Density Correction Intercept',
      [`${prefix}.Preparation.MoistureDensityCorrectionSlope`]: 'Moisture Density Correction Slope (b)',
      [`${prefix}.Preparation.MoistureDensityCorrectionIntercept`]: 'Moisture Density Correction Intercept',

      [`${prefix}.IsParticleDensityAssumed`]: 'Particle Density Determination',
      [`${prefix}.ParticleDensityAssumed`]: 'Assumed Particle Density',

      [`${prefix}.ReferenceDensity.ImportedTest`]: 'Reference Density',

      [`${prefix}.ReferenceDensityResults.ParticleDensity`]: 'Reference Particle Density',

      [`${prefix}.Measurements.Depth`]: 'Probe Depth',
      [`${prefix}.Measurements.NuclearDensityGaugeMode`]: 'Nuclear Density Gauge Mode',

      [`${prefix}.Measurements.AverageReadings.MeanWetDensity`]: 'Average Corrected Bulk Density',
      [`${prefix}.Measurements.AverageReadings.MeanMoistureDensity`]: 'Average Corrected Moisture Density',

      [`${prefix}.Results.MaximumDryDensity`]: 'Maximum Dry Density',
      [`${prefix}.Results.OptimumMoistureContent`]: 'Optimum Moisture Content',
      [`${prefix}.Results.InsituDryDensity`]: 'Dry Density',
      [`${prefix}.Results.RelativeCompaction`]: 'Relative Compaction',
      [`${prefix}.Results.InsituAirVoids`]: 'Air Voids',
      [`${prefix}.Results.ReportResultsOption`]: 'Reported Results',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.OptimumMoistureContent`]: '%',
      [`${prefix}.Results.RelativeCompaction`]: '%',
      [`${prefix}.Results.InsituAirVoids`]: '%',
    })
  );

export default getLabelConfig;
